import { BetrokkenStation } from "@/entities/betrokken-stations";
import { BeheerVestiging, Vestiging } from "@/entities/vestiging";
import { useEffect, useState } from "react";
import { VestigingenUpdateHandler } from "../../shared";
import { BestaandeAanvraagRegievoerder } from "../bestaande-aanvraag";
import { NieuweAanvraagRegievoerder } from "../nieuwe-aanvraag";

type FaciliteitenDetailsRegievoerderProps = {
    dossierId: string;
    vestigingen: Vestiging[];
    betrokkenStations: BetrokkenStation[];
    beheerVestigingen: BeheerVestiging[];
    onVestigingenUpdate: VestigingenUpdateHandler;
};

export function FaciliteitenDetailsRegievoerder({
    dossierId,
    vestigingen,
    betrokkenStations,
    beheerVestigingen,
    onVestigingenUpdate,
}: Readonly<FaciliteitenDetailsRegievoerderProps>) {
    const [variant, setVariant] = useState<"nieuweAanvraagRegievoerder" | "bestaandeAanvraagRegievoerder">(
        vestigingen.length > 0 ? "bestaandeAanvraagRegievoerder" : "nieuweAanvraagRegievoerder"
    );

    // make sure variant changes when react query refetches aangevraagdeVestigingen after the user submits vestigingen
    // If we move setVariant to the submit handler, a race condition occurs between updating the variant and refetching aangevraagdeVestigingen.
    // This can cause the UI to briefly show incorrect data. To avoid this, we update the variant in a useEffect that listens to aangevraagdeVestigingen changes.
    useEffect(() => {
        if (vestigingen.length > 0) {
            setVariant("bestaandeAanvraagRegievoerder");
        }
    }, [vestigingen]);

    if (variant === "nieuweAanvraagRegievoerder")
        return (
            <NieuweAanvraagRegievoerder
                dossierId={dossierId}
                vestigingen={vestigingen}
                beheerVestigingen={beheerVestigingen}
                betrokkenStations={betrokkenStations}
            />
        );
    if (variant === "bestaandeAanvraagRegievoerder") {
        return (
            <BestaandeAanvraagRegievoerder vestigingen={vestigingen} setVariant={setVariant} onVestigingenUpdate={onVestigingenUpdate} />
        );
    }
}
